import styled from 'styled-components';

export const GlobalContainer = styled.div`
@import '~antd/dist/antd.css';

`;
